import React from 'react';
import { Typography } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import { ColorPalette } from '../../styles/constants';

interface Props {
  title: string;
  content: React.ReactElement;
}

const makeStyles = () => ({
  tooltip: {
    bgcolor: ColorPalette.LIGHT_GRAY,
    '& .MuiTooltip-arrow': {
      color: ColorPalette.LIGHT_GRAY,
    },
    pl: 2,
    pr: 2,
    pt: 1,
    pb: 1,
    boxShadow: 3,
  },
  title: { color: ColorPalette.RAISIN_BLACK, fontSize: '16px' },
});

export function AppTooltipContainer({ title, content }: Props): JSX.Element {
  const style = makeStyles();

  return (
    <Tooltip
      title={<Typography sx={style.title}>{title}</Typography>}
      arrow
      componentsProps={{
        tooltip: {
          sx: style.tooltip,
        },
      }}
    >
      {content}
    </Tooltip>
  );
}
